export type BACKGROUND_STATUS = "success" | "info" | "warning" | "critical" | "regular";

export const STATUS_TO_CUSTOM_PROPERTY_NAME: Record<BACKGROUND_STATUS, string> = {
  info: "--p-surface-highlight-subdued",
  success: "--p-surface-success-subdued",
  warning: "--p-surface-warning-subdued",
  critical: "--p-surface-critical-subdued",
  regular: "--p-surface-regular-subdued"
};
